export default {
  mounted(element: HTMLElement): void {
    element.style.position = 'sticky';
    element.style.top = element.offsetTop.toString() + 'px';
  },
};
